import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

function Layout({ children }) {
  // Scroll progress bar
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Intersection Observer for reveal animations
  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');
    if (revealElements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );

    revealElements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [children]);

  return (
    <div className="layout">
      {/* Scroll Progress Bar */}
      <div className="scroll-progress-track">
        <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }} />
      </div>

      {/* Animated Grid */}
      <div className="animated-grid" />

      {/* Background Orbs */}
      <div className="bg-orbs">
        <div className="drift-orb drift-orb-1" />
        <div className="drift-orb drift-orb-2" />
        <div className="drift-orb drift-orb-3" />
      </div>

      {/* Floating Particles */}
      <div className="hero-particle-field">
        <div className="hero-particle particle-a" />
        <div className="hero-particle particle-b" />
        <div className="hero-particle particle-c" />
        <div className="hero-particle particle-d" />
        <div className="hero-particle particle-e" />
        <div className="hero-particle particle-f" />
        <div className="hero-particle particle-g" />
        <div className="hero-particle particle-h" />
        <div className="hero-particle particle-i" />
        <div className="hero-particle particle-j" />
      </div>

      {/* Floating Geometric Shapes */}
      <div className="float-geometric geo-1" />
      <div className="float-geometric geo-2" />
      <div className="float-geometric geo-3" />
      <div className="float-geometric geo-4" />
      <div className="float-geometric geo-5" />

      {/* Twinkle Stars */}
      <div className="twinkle-star star-1" />
      <div className="twinkle-star star-2" />
      <div className="twinkle-star star-3" />
      <div className="twinkle-star star-4" />
      <div className="twinkle-star star-5" />
      <div className="twinkle-star star-6" />
      <div className="twinkle-star star-7" />
      <div className="twinkle-star star-8" />

      {/* Hero Wave */}
      <div className="hero-wave" />

      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;